/* RESPONSIBLE TEAM: team-automation-foundations */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'operator_settings/duplicate_conversation_detection';
  },
});
